import React from 'react';
import PropTypes from 'prop-types';
import Typography from 'material-ui/Typography';
import { withStyles } from 'material-ui/styles/index';

const styles = () => ({
    sectionTitle: {
        fontSize: '12px',
        fontWeight: '500',
        color: '#999999',
        textTransform: 'uppercase',
        marginTop: '16px',
    },
});

function SectionTitle(props) {
    return (
        <Typography className={props.classes.sectionTitle}>
            {props.children}
        </Typography>
    );
}

SectionTitle.propTypes = {
    classes: PropTypes.object.isRequired,
    children: PropTypes.string.isRequired,
};

export default withStyles(styles)(SectionTitle);



// WEBPACK FOOTER //
// ./src/app/common/components/Typography/SectionTitle.js